module.exports = __webpack_public_path__ + "static/media/illustartion-decision.5de53ba4.svg";